import React from 'react';
import { FormattedMessage } from 'mz-intl';
import messages from '../../../messages.intl';

export default function SmsNotificationsDescription() {
  return <FormattedMessage message={messages.SMS_NOTIFICATIONS_DESCRIPTION} />;
}
